import { Link } from "react-router-dom";

const Dashboard_Aboutme = () => {
    return (
        <section className="about-modern">

            <div className="about-image">
                <img
                    src="/images/Dashboard/DashboardMe.jpg"
                    alt="About Me"
                    loading="lazy"
                />
            </div>

            <div className="about-overlay">
                <div className="about-card">

                    <span className="about-label">About Me</span>

                    <h2>
                        Hi, ich bin Laura 👋
                    </h2>

                    <p>
                        Reise, entdecke und sammle Erinnerungen rund um die Welt.
                        Wenn du mehr über mich erfahren willst, schau auf meiner About-Seite vorbei.
                    </p>

                    <Link to="/aboutme" className="about-btn">
                        Mehr über mich →
                    </Link>

                </div>
            </div>

        </section>
    );
};

export default Dashboard_Aboutme;